import axios from 'axios';
import { serviceUrl } from '../../App';
import { GetBackendUrlForGlobalFunctions } from '../../App';
export const getMasterAssignment = () => {
  return axios.get(GetBackendUrlForGlobalFunctions() + `assignment?where=true`);
};
export const deleteAssignment = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    GetBackendUrlForGlobalFunctions() + `assignment/delete`,
    obj,
    {
      headers,
    }
  );
};
export const addAssignment = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(GetBackendUrlForGlobalFunctions() + `assignment/add`, obj, {
    headers,
  });
};
export const editAssignment = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    GetBackendUrlForGlobalFunctions() + `assignment/update`,
    obj,
    {
      headers,
    }
  );
};
export const getAssignments = () => {
  return axios.get(
    GetBackendUrlForGlobalFunctions() + `assignment?where=false`
  );
};
export const getAssignmentsDetails = (id: any) => {
  return axios.get(
    GetBackendUrlForGlobalFunctions() +
      `assignment/team-trade-of-theAssignment?where=` +
      id
  );
};
export const setterTeamAndTradeToAssignment = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    GetBackendUrlForGlobalFunctions() +
      `assignment/set-team-trade-of-theAssignment`,
    obj,
    { headers }
  );
};
export const clearAssignmentTeamId = (id: Object) => {
  return axios.put(
    GetBackendUrlForGlobalFunctions() + `assignment/clear-team-id`,
    id
  );
};
